type ItemWithPosition = {
  position: number;
};

const compareByPosition = <ArrayElementType extends ItemWithPosition>(
  a: ArrayElementType,
  b: ArrayElementType,
) => a.position - b.position;

const updatePositions = <ArrayElementType extends ItemWithPosition>(
  array: ArrayElementType[],
): ArrayElementType[] =>
  array.map((element, index) => ({ ...element, position: index + 1 }));

export type ReorderByPositionParam<ArrayElementType extends ItemWithPosition> =
  {
    arrayToReorder: ArrayElementType[];
    oldPosition: number;
    nextPosition: number;
  };

export const reorderByPosition = <ArrayElementType extends ItemWithPosition>({
  arrayToReorder,
  oldPosition,
  nextPosition,
}: ReorderByPositionParam<ArrayElementType>): ArrayElementType[] => {
  const newArray = [...arrayToReorder];

  const indexOfItemToMove = newArray.findIndex(
    ({ position }) => position === oldPosition,
  );

  if (indexOfItemToMove !== -1) {
    const [itemToMove] = newArray.splice(indexOfItemToMove, 1);

    newArray.sort(compareByPosition);

    let indexToMoveItemTo = newArray.findIndex(
      ({ position }) => position >= nextPosition,
    );
    indexToMoveItemTo =
      indexToMoveItemTo === -1 ? newArray.length : indexToMoveItemTo;

    newArray.splice(indexToMoveItemTo, 0, {
      ...itemToMove,
      position: nextPosition,
    });
  }

  const sorted = newArray.sort(compareByPosition);

  const updated = updatePositions(sorted);

  return updated;
};
